/* kn-pdp-addons.js · PixelNova Solutions · 10/14/2026 */
(function (root) {
  'use strict';
  const bundleByFlag = {48054778069234: 'With USA Flag', 48055150936306: 'With Texas Flag'};
  // Kit-only variant: matches the new name and the old one so the rename in admin can happen before or after this file lands.
  const kitOnlyTitles = ['Flagpole Kit Only', 'Hardware Only'];
  const isKitOnly = v => kitOnlyTitles.includes(v.title);
  function quantity(value) {
    const n = Number(value);
    if (!Number.isInteger(n) || n < 1 || n > 99) throw new Error('Choose a quantity from 1 to 99.');
    return n;
  }
  function offers(config, id) {
    const main = config.variants.find(v => v.id === Number(id));
    if (!main?.available) return [];
    const result = [];
    const hardware = config.kitVariants.find(isKitOnly);
    const bundleTitle = bundleByFlag[main.id];
    const bundle = config.kitVariants.find(v => v.title === bundleTitle);
    if (main.eligible && hardware?.available && (!bundleTitle || bundle?.available)) {
      result.push({...hardware, key: 'kit', title: 'Add Flagpole Kit?', subtitle: '', bundle: bundleTitle ? bundle : null});
    }
    const match = config.companion?.variants.find(v => v.available && main.size && main.material && v.size === main.size && v.material === main.material);
    if (match) result.push({...match, key: 'companion', title: config.companion.title, subtitle: main.size + ' · ' + main.material});
    return result;
  }
  function order(config, state, properties = {}, sellingPlan = '') {
    const main = config.variants.find(v => v.id === Number(state.id));
    if (!main?.available) throw new Error('This flag is unavailable.');
    const count = quantity(state.quantity);
    const available = offers(config, state.id);
    const chosen = Object.entries(state.selected).map(([key, count]) => {
      const offer = available.find(v => v.key === key);
      if (!offer) throw new Error('An add-on no longer matches this flag. Please choose again.');
      return {...offer, quantity: quantity(count)};
    });
    const kit = chosen.find(v => v.key === 'kit');
    if (kit?.bundle && sellingPlan) throw new Error('The flagpole bundle cannot be combined with this selling plan.');
    const paired = kit?.bundle ? Math.min(count, kit.quantity) : 0;
    const lines = [];
    const line = (v, q, mainLine, extraProperties) => {
      if (!q) return;
      const item = {id: v.id, quantity: q};
      if (mainLine && Object.keys(properties).length) item.properties = properties;
      if (extraProperties) item.properties = extraProperties;
      if (mainLine && sellingPlan) item.selling_plan = sellingPlan;
      lines.push({item, price: v.price});
    };
    if (paired) line(kit.bundle, paired, true);
    line(main, count - paired, true);
    chosen.forEach(v => line(v, v.key === 'kit' ? v.quantity - paired : v.quantity, false, v.key === 'kit' && config.hardwareTitle ? {_kn_title: config.hardwareTitle} : null));
    return {items: lines.map(v => v.item), total: lines.reduce((total, v) => total + v.price * v.item.quantity, 0)};
  }
  const api = {offers, order};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document || root.customElements.get('kn-pdp-addons')) return;
  class Addons extends root.HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-kn-config]').textContent);
      this.form = this.closest('form');
      if (this.form?.getAttribute('id') !== this.dataset.formId) return;
      this.view = this.form?.closest('.productView');
      this.companion = this.form?.querySelector('[data-kn-companion-for]');
      if (!this.form || !this.view || !this.companion) return;
      this.state = {id: 0, quantity: 1, selected: {}};
      this.busy = false;
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: this.config.currency}).format(cents / 100);
      this.clickHandler = event => {
        const button = event.target.closest('[data-btn-addtocart]');
        if (!button || !this.isOwnForm(button.closest('form'))) return;
        if (!this.busy && (!Object.keys(this.state.selected).length || button.disabled)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submit(button.closest('form'), button);
      };
      this.submitHandler = event => {
        if (!this.isOwnForm(event.target) || (!this.busy && !Object.keys(this.state.selected).length)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submit(event.target, event.submitter || event.target.querySelector('[name="add"]'));
      };
      this.changeHandler = event => {
        if (this.contains(event.target) || this.companion.contains(event.target)) return;
        if (event.target.closest('.productView') === this.view || event.target.closest('sticky-add-to-cart')) {
          this.sync();
          queueMicrotask(() => this.sync());
        }
      };
      document.addEventListener('click', this.clickHandler, true);
      document.addEventListener('submit', this.submitHandler, true);
      document.addEventListener('change', this.changeHandler);
      document.addEventListener('input', this.changeHandler);
      this.observer = new MutationObserver(() => this.updateSubtotal());
      this.view.querySelectorAll('.money-subtotal').forEach(e => this.observer.observe(e, {childList: true, characterData: true, subtree: true}));
      this.sync();
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.clickHandler, true);
      document.removeEventListener('submit', this.submitHandler, true);
      document.removeEventListener('change', this.changeHandler);
      document.removeEventListener('input', this.changeHandler);
      this.observer?.disconnect();
      this.ready = false;
    }
    isOwnForm(form) {
      return form === this.form || form?.getAttribute('id') === 'product-form-sticky-' + this.config.productId;
    }
    mainQuantity(form = this.form) {
      if (form !== this.form) return form.querySelector('[name="quantity"]')?.value || 1;
      return this.view.querySelector('.productView-quantity:not(.hidden) [name="quantity"]')?.value || form.querySelector('[name="quantity"]')?.value || 1;
    }
    sync() {
      const picker = this.view.querySelector('variant-radios, variant-selects');
      const id = picker && 'currentVariant' in picker && !picker.currentVariant ? 0 : Number(this.form.querySelector('[name="id"]')?.value);
      if (id !== this.state.id) {
        this.state.id = id;
        this.state.selected = {};
        this.render();
      }
      this.state.quantity = Number(this.mainQuantity());
      this.updateSubtotal();
    }
    render() {
      this.error('');
      const kitTarget = this.querySelector('[data-kn-offers]');
      const companionTarget = this.companion.querySelector('[data-kn-companion-offers]');
      kitTarget.replaceChildren();
      companionTarget.replaceChildren();
      const available = offers(this.config, this.state.id);
      this.hidden = !available.some(v => v.key === 'kit');
      this.companion.hidden = !available.some(v => v.key === 'companion');
      for (const item of available) {
        const row = document.createElement('div'); row.className = 'kn-row';
        const label = document.createElement('label'); label.className = 'kn-choice';
        const check = document.createElement('input'); check.type = 'checkbox'; check.dataset.knChoice = item.key;
        const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.width = 48; image.height = 54; image.loading = 'lazy';
        const copy = document.createElement('span'); copy.className = 'kn-copy';
        const title = document.createElement('strong'); title.textContent = item.title;
        copy.append(title);
        if (item.subtitle) {
          const subtitle = document.createElement('span'); subtitle.textContent = item.subtitle; copy.append(subtitle);
        }
        label.append(check, image, copy);
        const side = document.createElement('div'); side.className = 'kn-side';
        const price = document.createElement('strong'); price.textContent = '+' + this.money(item.price);
        const qtyLabel = document.createElement('label'); qtyLabel.textContent = 'Qty';
        const qty = document.createElement('input'); qty.type = 'number'; qty.min = 1; qty.max = 99; qty.step = 1; qty.value = 1; qty.disabled = true; qty.setAttribute('aria-label', item.title + ' quantity');
        qtyLabel.append(qty); side.append(price, qtyLabel); row.append(label, side);
        if (item.key === 'kit') {
          const contents = document.createElement('div'); contents.className = 'kn-kit-contents';
          const heading = document.createElement('strong'); heading.textContent = 'Includes';
          const list = document.createElement('ul');
          for (const part of ['6 ft × 1 in silver aluminum flagpole', 'Rotating rings with clips', 'Black end plug', 'Chrome ball ornament with ring', 'Cast aluminum mounting bracket']) {
            const line = document.createElement('li'); line.textContent = part; list.append(line);
          }
          contents.append(heading, list);
          row.append(contents);
        }
        check.addEventListener('change', () => {
          if (check.checked) this.state.selected[item.key] = 1; else delete this.state.selected[item.key];
          qty.value = 1; qty.disabled = !check.checked; row.classList.toggle('selected', check.checked);
          this.updateSubtotal();
        });
        qty.addEventListener('input', () => {this.state.selected[item.key] = Number(qty.value); this.updateSubtotal();});
        (item.key === 'kit' ? kitTarget : companionTarget).append(row);
      }
    }
    updateSubtotal() {
      if (!this.state || !this.form) return;
      this.state.quantity = Number(this.mainQuantity());
      const selected = Object.keys(this.state.selected).length > 0;
      if (!selected && !this.overrodeSubtotal) {this.error(''); return;}
      try {
        const result = order(this.config, this.state);
        for (const subtotal of this.view.querySelectorAll('.money-subtotal')) {
          const text = this.money(result.total);
          if (subtotal.textContent !== text) subtotal.textContent = text;
        }
        this.overrodeSubtotal = selected;
        this.error('');
      } catch (err) {
        if (Object.keys(this.state.selected).length) this.error(err.message);
      }
    }
    error(message) {
      const node = this.querySelector('[data-kn-error]');
      if (!node) return;
      node.textContent = message;
      node.hidden = !message;
      const hasKit = Boolean(this.querySelector('[data-kn-choice="kit"]'));
      this.querySelector('h2').hidden = !hasKit;
      this.hidden = !hasKit && !message;
    }
    async submit(form, button) {
      if (this.busy) return;
      this.sync();
      try {
        const properties = {};
        const fields = new FormData(this.form);
        this.view.querySelectorAll('.line-item-property__field [name^="properties["]').forEach(input => {
          if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
          if (input.type === 'file' && input.files.length) throw new Error('Please purchase customized flags separately from these add-ons.');
          if (input.type !== 'file') fields.set(input.name, input.value);
        });
        for (const [key, value] of fields) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value !== 'string') {if (value.size) throw new Error('Please purchase customized flags separately from these add-ons.');}
          else if (match) properties[match[1]] = value;
        }
        this.state.quantity = Number(this.mainQuantity(form));
        const plan = fields.get('selling_plan') || '';
        const result = order(this.config, this.state, properties, plan);
        this.busy = true;
        this.error('');
        this.setBusy(true);
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: result.items})});
        const added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || added.message || 'The selected items could not be added.');
        const cartResponse = await fetch(base + 'cart.js', {headers: {'Accept':'application/json'}});
        if (!cartResponse.ok) {this.goToCart(); return;}
        const cart = await cartResponse.json();
        const drawer = document.getElementById('halo-cart-sidebar');
        if (window.after_add_to_cart?.type === 'quick_cart' && window.quick_cart?.show && window.quick_cart.type !== 'popup' && drawer && window.sharedFunctions?.updateSidebarCart) {
          document.body.classList.remove('show-mobile-options');
          window.sharedFunctions.updateSidebarCart(cart);
          document.body.classList.add('cart-sidebar-show');
        } else this.goToCart();
        this.state.selected = {};
        this.render();
        this.updateSubtotal();
      } catch (err) {
        this.error(err.message + (this.busy ? ' Check your cart before trying again.' : ''));
        this.querySelector('[data-kn-error]')?.focus();
      } finally {
        this.setBusy(false);
        this.busy = false;
      }
    }
    setBusy(busy) {
      if (busy) {
        this.lockedInputs = [...this.view.querySelectorAll('variant-radios input,variant-selects select,.productView-quantity input,.productView-quantity button,.kn-pairings input'), ...document.querySelectorAll('sticky-add-to-cart input,sticky-add-to-cart select,sticky-add-to-cart .btn-quantity')].map(input => ({input, disabled: input.disabled}));
        this.lockedInputs.forEach(({input}) => {input.disabled = true;});
      } else {
        this.lockedInputs?.forEach(({input, disabled}) => {if (input.isConnected) input.disabled = disabled;});
        this.lockedInputs = null;
      }
      for (const form of [this.form, document.getElementById('product-form-sticky-' + this.config.productId)]) {
        form?.querySelectorAll('[name="add"]').forEach(button => {
          if (busy) {button.dataset.knWasDisabled = String(button.disabled); button.disabled = true; button.classList.add('is-loading');}
          else if ('knWasDisabled' in button.dataset) {button.disabled = button.dataset.knWasDisabled === 'true'; button.classList.remove('is-loading'); delete button.dataset.knWasDisabled;}
        });
      }
      this.setAttribute('aria-busy', String(busy));
      this.companion?.setAttribute('aria-busy', String(busy));
    }
    goToCart() {
      window.location.assign(window.routes?.cart || (window.Shopify?.routes?.root || '/') + 'cart');
    }
  }
  root.customElements.define('kn-pdp-addons', Addons);
})(typeof window === 'undefined' ? globalThis : window);